import { Injectable } from '@angular/core';
import { MarketingLoopingContentMenuViewModel } from '../marketing-looping-content-menu-view-model';

@Injectable()
export class MarketingSmartPlaylistMenuViewModel extends MarketingLoopingContentMenuViewModel {}
